module.exports = __webpack_public_path__ + "media/images/countrysquared/io-10158fdec52c1b305a1199ea0d10cdd7.svg";